// removed by extract-text-webpack-plugin
module.exports = {"voteButton":"index-module__voteButton___1AO7S","pointerEventNone":"index-module__pointerEventNone___amjI4","hideTooltip":"index-module__hideTooltip___brFPR"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/graphql/AdminVoteValidatorCommentButton/index.module.scss
// module id = 1995
// module chunks = 157